module.exports = __webpack_public_path__ + "img/Fake_Video-8.c9f45224.jpg";